import React, { useState, useEffect } from 'react';
import './InfoUserMain.css';
import baseURL from '../../url';
import { Link as Anchor } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faEnvelope,
    faPhone,
    faThLarge,
    faSignOutAlt,
    faCopy,
    faCheck,
    faExternalLinkAlt,
    faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

export default function InfoUserMain({ usuario: initialUser, onClose }) {
    const [usuario, setUsuario] = useState(initialUser || {});
    const [loading, setLoading] = useState(!initialUser?.idUsuario);
    const [copiedEmail, setCopiedEmail] = useState(false);

    useEffect(() => {
        if (initialUser?.idUsuario) {
            setUsuario(initialUser);
            setLoading(false);
            return;
        }

        const fetchUserData = async () => {
            try {
                const response = await fetch(`${baseURL}/userLogued.php`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data && data.idUsuario) {
                        setUsuario(data);
                        setLoading(false);
                        return;
                    }
                }
            } catch (error) {
                console.error('Error al obtener datos:', error);
            }

            const localUser = localStorage.getItem('usuario');
            if (localUser) {
                try {
                    setUsuario(JSON.parse(localUser));
                } catch (e) {
                    setUsuario({});
                }
            }
            setLoading(false);
        };

        fetchUserData();
    }, [initialUser]);

    const handleCopyEmail = (email) => {
        if (!email) return;
        navigator.clipboard.writeText(email);
        setCopiedEmail(true);
        setTimeout(() => setCopiedEmail(false), 2000);
    };

    const handleLogout = async () => {
        try {
            await fetch(`${baseURL}/logout.php`, {
                method: 'GET',
                credentials: 'include'
            });
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        } finally {
            localStorage.removeItem('usuario');
            toast.info('Sesión cerrada correctamente');
            if (onClose) onClose();
            setTimeout(() => {
                const homePath = (typeof window !== 'undefined' && window.location.pathname.startsWith('/clubvendemas')) ? '/clubvendemas/' : '/';
                window.location.href = homePath;
            }, 400);
        }
    };

    if (loading) {
        return (
            <div className='infoUser-loading'>
                <div className='infoUser-spinner'></div>
                <p>Cargando información...</p>
            </div>
        );
    }

    if (!usuario?.idUsuario) {
        return null;
    }

    return (
        <div className='infoUserModern'>
            
            {/* 1. Header con Avatar y Bienvenida */}
            <div className='infoUser-avatar-section'>
                <div className='infoUser-avatar-box'>
                    <div className='infoUser-avatar-circle'>
                        {usuario?.nombre ? usuario.nombre.charAt(0).toUpperCase() : <FontAwesomeIcon icon={faUser} />}
                    </div>
                    <span className='infoUser-status-dot' title='En Línea'></span>
                </div>
                <h4 className='infoUser-name'>{usuario?.nombre || 'Usuario Registrado'}</h4>
                <div className='infoUser-badge-verified'>
                    <span className='verified-dot'></span>
                    <span>Cuenta Activa</span>
                </div>
            </div>

            {/* 2. Tarjeta con Datos de Contacto */}
            <div className='infoUser-details-card'>
                {usuario?.email && (
                    <div className='infoUser-field-item'>
                        <div className='field-icon-box'>
                            <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                        <div className='field-content'>
                            <span className='field-label'>Correo Electrónico</span>
                            <span className='field-value'>{usuario.email}</span>
                        </div>
                        <button 
                            className='btn-copy-field' 
                            onClick={() => handleCopyEmail(usuario.email)}
                            title='Copiar correo'
                        >
                            <FontAwesomeIcon icon={copiedEmail ? faCheck : faCopy} />
                        </button>
                    </div>
                )}

                {usuario?.telefono && (
                    <div className='infoUser-field-item'>
                        <div className='field-icon-box'>
                            <FontAwesomeIcon icon={faPhone} />
                        </div>
                        <div className='field-content'>
                            <span className='field-label'>Teléfono / WhatsApp</span>
                            <span className='field-value'>{usuario.telefono}</span>
                        </div>
                        <a 
                            href={`https://wa.me/${usuario.telefono.replace(/\D/g, '')}`} 
                            target='_blank' 
                            rel='noopener noreferrer' 
                            className='btn-copy-field wa-btn'
                            title='Abrir WhatsApp'
                        >
                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                        </a>
                    </div>
                )}
            </div>

            {/* 3. Botones de Acción (Dashboard y Cerrar Sesión) */}
            <div className='infoUser-actions'>
                <Anchor 
                    to='/dashboard' 
                    className='btn-modal-dashboard' 
                    onClick={() => onClose && onClose()}
                >
                    <div className='btn-dash-left'>
                        <div className='btn-dash-icon'>
                            <FontAwesomeIcon icon={faThLarge} />
                        </div>
                        <div className='btn-dash-texts'>
                            <span className='dash-btn-title'>Dashboard</span>
                            <span className='dash-btn-sub'>Panel de administración</span>
                        </div>
                    </div>
                    <FontAwesomeIcon icon={faArrowRight} className='btn-dash-arrow' />
                </Anchor>

                <button onClick={handleLogout} className='btn-modal-logout'>
                    <FontAwesomeIcon icon={faSignOutAlt} />
                    <span>Cerrar Sesión</span>
                </button>
            </div>

        </div>
    );
}

